export const REG_CODE_STORAGE_KEY = 'edatlink_regCode';

export const storeRegCode = (regCode?: string | null) => {
  if (regCode) {
    sessionStorage.setItem(REG_CODE_STORAGE_KEY, regCode);
  }
  return regCode || '';
};

export const getStoredRegCode = () => {
  return sessionStorage.getItem(REG_CODE_STORAGE_KEY) || '';
};

export const getActiveRegCode = (searchParams?: URLSearchParams) => {
  const currentSearchParams = searchParams || new URLSearchParams(location.search);
  const regCode = currentSearchParams.get('regCode');
  if (regCode) {
    return storeRegCode(regCode);
  }
  return getStoredRegCode();
};

export const appendRegCodeToUrl = (url: string, regCode?: string | null) => {
  const activeRegCode = regCode || getStoredRegCode();
  if (!activeRegCode) {
    return url;
  }
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}regCode=${encodeURIComponent(activeRegCode)}`;
};
